const init = () => {
    document.addEventListener('DOMContentLoaded', function() {
        var $components = jQuery('.c-author-about');
        if (!$components.length) return;

        // Store original heights for each description
        var descriptionHeights = {};

        function initializeAuthorAbout() {
            // Handle multiple author-about components on the same page
            $components.each(function() {
                var $component = jQuery(this);
                var $descriptions = $component.find('.c-author-about__desc');
                
                $descriptions.each(function() {
                    var $description = jQuery(this);
                    var $readMoreButton = $description.siblings('.c-author-about__read-more');
                    
                    if (!$readMoreButton.length) return;
                    
                    var descriptionId = $description.attr('data-description-id') || 
                        'desc-' + Math.random().toString(36).substr(2, 9);
                    $description.attr('data-description-id', descriptionId);
                    
                    $description.css('transition', 'height 0.3s ease-in-out');
                    
                    // Temporarily set height to auto to get the full height
                    $description.css('height', 'auto');
                    const descriptionHeight = $description.height();
                    descriptionHeights[descriptionId] = descriptionHeight;
                    
                    if (descriptionHeight < 100) {
                        $description.addClass('is-short');
                        $description.css('height', 'auto');
                    } else {
                        $description.css('height', '96px');
                    }

                    // Remove any existing click handlers to prevent duplicates
                    $readMoreButton.off('click.author-about');
                    $readMoreButton.on('click.author-about', function(e) {
                        e.preventDefault();
                        
                        if ($description.hasClass('is-open')) {
                            $description.removeClass('is-open');
                            $description.css('height', '96px');
                            $readMoreButton.text('Read more');
                        } else {
                            $description.addClass('is-open');
                            $description.css('height', descriptionHeights[descriptionId] + 10 + 'px');
                            $readMoreButton.text('Read less');
                        }
                    });
                });
            });
        }

        // Initialize on load
        initializeAuthorAbout();

        // Handle window resize with debouncing
        var resizeTimeout;
        jQuery(window).on('resize.author-about', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                // Recalculate heights on resize
                $components.each(function() {
                    var $component = jQuery(this);
                    var $descriptions = $component.find('.c-author-about__desc');
                    
                    $descriptions.each(function() {
                        var $description = jQuery(this);
                        var descriptionId = $description.attr('data-description-id');
                        
                        if (!descriptionId) return;
                        
                        // Always recalculate the full height on resize
                        // Temporarily set height to auto to get the new full height
                        $description.css('height', 'auto');
                        const newDescriptionHeight = $description.height();
                        descriptionHeights[descriptionId] = newDescriptionHeight;
                        
                        if (newDescriptionHeight < 100) {
                            $description.addClass('is-short');
                            $description.css('height', 'auto');
                        } else {
                            $description.removeClass('is-short');
                            
                            // If currently open, use the new full height, otherwise use 96px
                            if ($description.hasClass('is-open')) {
                                $description.css('height', newDescriptionHeight + 10 + 'px');
                            } else {
                                $description.css('height', '96px');
                            }
                        }
                    });
                });
            }, 150);
        });
    });
};

export default init;